import React, { useEffect, useState } from "react";
import classNames from "classnames";
import moment from "moment";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import highchartsTimeline from "highcharts/modules/timeline";

import { Column, Row } from "components/Layout";
import Checkbox from "components/Checkbox";
import styles from "./_charts.module.scss";

// init the module
highchartsTimeline(Highcharts);

let _chartOptions = {
	legend: { enabled: true },
	title: { text: null },
	chart: { zoomType: 'x', type: 'timeline' },
	xAxis: { type: 'datetime' },
	yAxis: {
		gridLineWidth: 1,
		title: null,
		labels: { enabled: false }
	},
	tooltip: {
		style: { width: 300 },
		pointFormat: '<span>Open: {point.openTime}</span><br/><span>Close: {point.closeTime}<br/><i>{point.description}</i>',
	},
	time: { timezone: 'Europe/Rome', useUTC: false },
};

export default function Timeline({ data, eventTypes }) {
	let labels = eventTypes.map(a => a.id);

	const [selectedLabels, setSelectedLabels] = useState([]);
	const [chartOptions, setChartOptions] = useState(_chartOptions);
	useEffect(() => setSelectedLabels(labels), [eventTypes])
	useEffect(updateChart, [data, selectedLabels, eventTypes])

	function updateChart() {
		let chartOptions = Object.assign({}, _chartOptions)
		let series = [];

		data.sort((a, b) => moment(a.openTime).valueOf() - moment(b.openTime).valueOf())

		eventTypes.forEach((e, i) => {
			e.color = Highcharts.getOptions().colors[i]
			let serie = {}
			serie.data = data.filter(d => e.alertIds.includes(d.type)).map(d => (
				{
					name: d.typeLabel,
					description: d.description,
					x: moment(d.openTime).valueOf(),
					openTime: moment(d.openTime).format("L"),
					closeTime: moment(d.closeTime).format("L"),
					label: d.typeLabel,
					color: e.color,
				}
			))
			serie.visible = selectedLabels.findIndex(sl => sl === e.id) > -1
			serie.marker = { symbol: 'circle' }
			serie.dataLabels = {
				allowOverlap: false,
				format: '<span style="color:{point.color}">● </span><span style="font-weight: bold;" > ' +
					'{point.x:%d %b %Y}</span><br/>{point.label}'
			}
			series.push(serie)
		})
		chartOptions.series = series
		setChartOptions(chartOptions)
	}

	function addLabel(label) {
		let sl = selectedLabels.slice();
		sl.push(label);
		setSelectedLabels(sl);
	}

	function removeLabel(label) {
		let sl = selectedLabels.slice();
		sl = sl.filter(l => l !== label);
		setSelectedLabels(sl);
	}

	return (
		<Row>
			<Column style={{ flexGrow: 5, minWidth: '300px' }}>
				<HighchartsReact
					highcharts={Highcharts}
					options={chartOptions}
					immutable={true}
				/>
			</Column>

			<Column style={{ flexGrow: 1 }} className={classNames(styles.box, styles.legendContainer)}>
				<div className={styles.legendContainer__header}>
					<div className={styles["legendContainer__header-title"]}>LEGENDA</div>
					<div className={styles["legendContainer__header-subtitle"]}>Scegli quale dato visualizzare</div>
				</div>

				<div className={styles.legendOptions}>
					{labels.map(l =>
						<div className={styles.legendOptions__option} key={`${l}-option`}>
							<Checkbox
								color={"red"}
								onCheck={() => selectedLabels.findIndex(sl => sl === l) < 0 ? addLabel(l) : removeLabel(l)}
								checked={selectedLabels.findIndex(sl => sl === l) !== -1}
							/>
							<div className={styles.legendOptions__label}>
								<div>
									<div className={styles.legendOptions__optionFlag}
										style={{ backgroundColor: eventTypes.find(e => e.id === l).color, marginRight: 15 }} />
								</div>
								{eventTypes.find(e => e.id === l).label}
							</div>
						</div>
					)}
				</div>
			</Column>
		</Row>
	)
}
